export type MetricsEntityFlavor = 'AUDIO' | 'VIDEO'

export function podcastFlavor(hasVideo: boolean): MetricsEntityFlavor {
    return hasVideo ? 'VIDEO' : 'AUDIO'
}
